import React, { useEffect, useState } from "react";
import { Alert, Col, Form } from "react-bootstrap";
import Message from "./Message";

const FallRiskAssessment = ({ currentAge, patientVehicle, setHDFS, HDFS }) => {
  const [selectedAge, setSelectedAge] = useState(
    currentAge.years > 13
      ? "1"
      : currentAge.years > 7
      ? "2"
      : currentAge.years > 3
      ? "3"
      : "4",
  );
  const [selectedGender, setSelectedGender] = useState(
    HDFS.selectedGender
      ? HDFS?.selectedGender
      : patientVehicle?.gender?.toString() === "0"
      ? "2"
      : patientVehicle?.gender?.toString() === "1"
      ? "1"
      : "0",
  );
  const [selectedMedication, setSelectedMedication] = useState(
    HDFS?.selectedMedication || "0",
  );
  const [selectedSurgery, setSelectedSurgery] = useState(
    HDFS?.selectedSurgery || "0",
  );
  const [selectedEnviromental, setSelectedEnviromental] = useState(
    HDFS?.selectedEnviromental || "0",
  );
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(
    HDFS?.selectedDiagnosis || "0",
  );
  const [selectedCognitive, setSelectedCognitive] = useState(
    HDFS?.selectedCognitive || "0",
  );
  const [error, setError] = useState("");
  const [riskHandled, setRiskHandled] = useState(HDFS?.riskHandled || false);

  const ageOptions = [
    { label: "Select", value: 0, disabled: true },
    { label: "Under 3 years", value: "4" },
    { label: "3 - 7 years", value: "3" },
    { label: "7 - 13 years", value: "2" },
    { label: "13 years and older", value: "1" },
  ];
  const genderOptions = [
    { label: "Select", value: "0", disabled: true },
    { label: "Male", value: "2" },
    { label: "Female", value: "1" },
  ];
  const diagnosisOptions = [
    { label: "Select", value: "0", disabled: true },

    { label: "Neurological diagnosis", value: "4" },
    {
      label:
        "Altered oxygenation (respiratory, dehydration, anemia, anorexia, syncope, dizziness, etc.)",
      value: "3",
    },
    { label: "Psychological / behavioral disorder", value: "2" },
    { label: "Other diagnosis", value: "1" },
  ];

  const cognitiveOptions = [
    { label: "Select", value: "0", disabled: true },

    { label: "Not aware of own limitations", value: "3" },
    { label: "Forgets own limitations", value: "2" },
    { label: "Oriented to own ability", value: "1" },
  ];

  const environmentalOptions = [
    { label: "Select", value: "0", disabled: true },

    {
      label: "History of falls, or fall occurred while patient was in a bed",
      value: "4",
    },
    {
      label: "Patient uses an assistive device, or is in a crib / furniture",
      value: "3",
    },
    { label: "Patient is confined to bed", value: "2" },
    { label: "Outpatient area", value: "1" },
  ];

  const surgeryOptions = [
    { label: "Select", value: "0", disabled: true },

    { label: "Within 24 hours", value: "3" },
    { label: "Within 48 hours", value: "2" },
    { label: "More than 48 hours, or none", value: "1" },
  ];

  const medicationOptions = [
    { label: "Select", value: "0", disabled: true },
    {
      label:
        "Multiple sedatives, hypnotics, antidepressants, laxatives, diuretics, narcotics",
      value: "3",
    },
    { label: "One of the above medications", value: "2" },
    { label: "Other medications, or none", value: "1" },
  ];

  const LOW_RISK_INTERVENTIONS = [
    "Orient patient and family to the surroundings and call-light use",
    "Keep the bed in the lowest position with wheels locked",
    "Keep frequently used items within easy reach",
    "Provide non-slip footwear",
    "Supervise or assist during transfers and toileting",
    "Reassess the score whenever the patient's condition changes",
  ];

  const HIGH_RISK_INTERVENTIONS = [
    ...LOW_RISK_INTERVENTIONS,
    'Apply a "Fall Risk" wrist band and place a fall-risk sign at the bedside',
    "Activate a bed or chair alarm",
    "Increase rounding to at least once every hour",
    "Consider one-on-one supervision for patients who cannot follow instructions",
    "Request a physical therapy consult for gait and mobility training",
    "Hand off fall-risk status at every shift change",
  ];

  const [calculatedScore, setCalculatedScore] = useState(0);

  const isHighRisk = calculatedScore >= 12;
  const interventions = isHighRisk
    ? HIGH_RISK_INTERVENTIONS
    : LOW_RISK_INTERVENTIONS;

  const handleCalculation = () => {
    if (
      selectedAge === "0" ||
      selectedCognitive === "0" ||
      selectedDiagnosis === "0" ||
      selectedEnviromental === "0" ||
      selectedGender === "0" ||
      selectedMedication === "0" ||
      selectedSurgery === "0"
    ) {
      setError("Kindly, compelete all items then press calculate");

      return;
    }
    setRiskHandled(!riskHandled);
  };
  useEffect(() => {
    setHDFS({
      selectedAge,
      selectedCognitive,
      selectedDiagnosis,
      selectedEnviromental,
      selectedGender,
      selectedMedication,
      selectedSurgery,
      riskHandled,
    });
    setCalculatedScore(
      Number(selectedAge) +
        Number(selectedGender) +
        Number(selectedMedication) +
        Number(selectedSurgery) +
        Number(selectedEnviromental) +
        Number(selectedDiagnosis) +
        Number(selectedCognitive),
    );
  }, [
    selectedAge,
    selectedGender,
    selectedMedication,
    selectedSurgery,
    selectedEnviromental,
    selectedDiagnosis,
    selectedCognitive,
    riskHandled,
  ]);
  return (
    <>
      <Form>
        <Form.Group controlId="ageScore">
          <Form.Label>Age</Form.Label>
          <Form.Control
            as="select"
            value={selectedAge}
            onChange={(e) => setSelectedAge(e.target.value)}
            className="custom-select"
            isValid={selectedAge}
            isInvalid={!selectedAge}
          >
            {ageOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="genderScore">
          <Form.Label>Gender</Form.Label>
          <Form.Control
            as="select"
            value={selectedGender}
            onChange={(e) => setSelectedGender(e.target.value)}
            className="custom-select"
            isValid={selectedGender}
            isInvalid={selectedGender === "0"}
          >
            {genderOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="diagScore">
          <Form.Label>Diagnosis</Form.Label>
          <Form.Control
            as="select"
            value={selectedDiagnosis}
            onChange={(e) => setSelectedDiagnosis(e.target.value)}
            className="custom-select"
            isValid={selectedDiagnosis}
            isInvalid={selectedDiagnosis === "0"}
          >
            {diagnosisOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="cogScore">
          <Form.Label>Cognitive Status</Form.Label>
          <Form.Control
            as="select"
            value={selectedCognitive}
            onChange={(e) => setSelectedCognitive(e.target.value)}
            className="custom-select"
            isValid={selectedCognitive}
            isInvalid={selectedCognitive === "0"}
          >
            {cognitiveOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="enviroScore">
          <Form.Label>Enviromental</Form.Label>
          <Form.Control
            as="select"
            value={selectedEnviromental}
            onChange={(e) => setSelectedEnviromental(e.target.value)}
            className="custom-select"
            isValid={selectedEnviromental}
            isInvalid={selectedEnviromental === "0"}
          >
            {environmentalOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="surgScore">
          <Form.Label>Surgerical Status</Form.Label>
          <Form.Control
            as="select"
            value={selectedSurgery}
            onChange={(e) => setSelectedSurgery(e.target.value)}
            className="custom-select"
            isValid={selectedSurgery}
            isInvalid={selectedSurgery === "0"}
          >
            {surgeryOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="medScore">
          <Form.Label>Medication</Form.Label>
          <Form.Control
            as="select"
            value={selectedMedication}
            onChange={(e) => setSelectedMedication(e.target.value)}
            className="custom-select"
            isValid={selectedMedication}
            isInvalid={selectedMedication === "0"}
          >
            {medicationOptions.map((o) => (
              <option key={o.value} disabled={o.disabled} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
      </Form>
      {error && (
        <Message
          children={"Kindly, compelete all items firstly"}
          variant={`danger`}
          setMessage={setError}
        />
      )}
      <div className="text-center ">
        <Form.Check
          type="checkbox"
          id="pediaFall"
          checked={riskHandled}
          label={
            <span
              onClick={() => handleCalculation()}
              className={riskHandled ? "text-success" : "text-danger"}
            >
              {`Fall Risk Score is ${calculatedScore} and all recommended measures are ${
                !riskHandled ? "NOT " : ""
              }done`}
            </span>
          }
        />
      </div>

      {!riskHandled && (
        <Alert variant={isHighRisk ? "danger" : "success"} className="m-4 row">
          <Col className="col-sm-10">
            <>
              <h5>Risk Level: {isHighRisk ? "High" : "Low"}</h5>
              <h5>Recommended Interventions:</h5>
              <ul>
                {interventions.map((intervention, index) => (
                  <li key={index}>{intervention}</li>
                ))}
              </ul>{" "}
            </>
          </Col>
        </Alert>
      )}
    </>
  );
};

export default FallRiskAssessment;
